import { Box, Typography } from '@mui/material';
import { numberFormatterDollar } from '@src/app/utils/GenericUtils';
import { FC } from 'react';

export interface PortfolioValueProps {
  totalValue?: number;
}

const PortfolioValue: FC<PortfolioValueProps> = ({ totalValue }: PortfolioValueProps): JSX.Element => {
  return (
    <Box component="div" display="flex" flexDirection="column" gap={1} flex={1}>
      <Typography fontWeight={500} fontSize="16px" color="#222222">
        Total Value
      </Typography>
      <Typography fontWeight={600} fontSize={28} color="#222222">
        {numberFormatterDollar(totalValue ?? 0, 2)}
      </Typography>
    </Box>
  );
};

export default PortfolioValue;
